import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {CATALOGUE_ROUTES, PRICING_ROUTES} from "@constants"
import CatalogueGeneralPage from "./General";
import CatalogueDetailsPage from "./Details";
import CatalogueLegacyIframePage from "./Legacy";


export const CatalogueRoutes = {
    path: CATALOGUE_ROUTES.PATH,
    title: CATALOGUE_ROUTES.TITLE,
    accessKey: CATALOGUE_ROUTES.ACCESS_KEY,
    icon: 'sitemap',
	iconWeight: 'light',
    element: <AppLayout />,
    description: "Know and compare the product - price mix of different retailers",
    children: [{
        element: <Navigate to={CATALOGUE_ROUTES.PATH} replace />,  index: true
    }, {
        title: 'Catalogue Analyzer',
        path: CATALOGUE_ROUTES.ANALYZER_PATH,
        dashboardKey: CATALOGUE_ROUTES.ACCESS_KEY,
        element: <CatalogueGeneralPage />
    }, {
        path: 'divider'
    }, {
        title: 'Catalogue Details',
        path: CATALOGUE_ROUTES.DETAILS_PATH,
        dashboardKey: CATALOGUE_ROUTES.DETAILS_ID,
        element: <CatalogueDetailsPage />
    },{
        title: 'Catalogue Legacy',
        path: CATALOGUE_ROUTES.LEGACY_PATH,
        dashboardKey: CATALOGUE_ROUTES.LEGACY_ID,
        element: <CatalogueLegacyIframePage />
    }
    ]
}